/**
 *
 * This is a `smart` component. It will pass along an impression info for an
 * impression of the same ID, if it has been fired
 *
 */
import { connect } from 'react-redux'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import ElementInteraction from './element-interaction';
export default connect(function (state, ownProps) {
  return {
    impressionId: get(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId"))
  };
})(ElementInteraction);